<template>
  <div class="login-phone-password-container">
    <div class="content">
      <div class="head">
        <div class="close" @click="$router.back()"></div>
        <div class="title">重置密码</div>
      </div>
      <div class="tip">
        请设置登录密码，需要8-20位字符，必须包含 字母/数字/字符中俩种以上组合
      </div>
      <Form class="form" ref="form">
        <Field v-model="phone" label="+ 86" label-width="40" type="tel" />
        <Field
          v-model="password"
          placeholder="请输入新密码"
          type="password"
          :rules="[{ validator: validPassword, message: '请正确输入新密码' }]"
        />
        <div class="btn-box">
          <Button class="btn" @click="nextHandle" :loading="loading"
            >下一步</Button
          >
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import { validPassword } from "@/utils/vaildate";
import { Form, Field, Toast, Button, Notify } from "vant";
export default {
  components: { Form, Field, Button },
  data() {
    return {
      loading: false,
      validPassword,
      phone: this.$route.query.phone,
      password: "",
    };
  },
  methods: {
    nextHandle() {
      if (/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.phone)) {
        this.$refs.form
          .validate()
          .then((res) => {
            this.loading = true;
            this.$store
              .dispatch("sms/loginSendCode", this.phone)
              .then((res) => {
                this.loading = false;
                res && Toast.success("已发送验证码");
                this.$router.push({
                  name: "LoginPhoneCode",
                  query: {
                    ...this.$route.query,
                    phone: this.phone,
                    newPassword: this.password,
                    type: "forget_password",
                  },
                });
              })
              .catch(() => {
                this.loading = false;
              });
          })
          .catch((err) => {
            Notify("信息填写有误");
          });
      } else {
        Toast.fail("请输入正确的手机号");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.close {
  display: inline-block;
  width: 30px;
  height: 4px;
  background: #333;
  border-radius: 4px;
  transform: rotate(45deg);
  &::after {
    content: "";
    display: block;
    width: 30px;
    height: 4px;
    background: #333;
    border-radius: 4px;
    transform: rotate(-90deg);
  }
}
.login-phone-password-container {
  height: 100vh;
  width: 100vw;
  .content {
    width: 100%;
    padding: 0 40px;
  }
  .head {
    display: flex;
    align-items: center;
    padding: 30px 0;
    .title {
      flex: 1;
      font-size: 28px;
      line-height: 1;
      text-indent: -20px;
    }
  }
  .form {
    padding-top: 136px;
    .input {
      flex: 1;
      padding: 20 0;
      font-size: 36px;
      &::placeholder {
        color: #aeaeae;
      }
    }
    .btn {
      margin-top: 80px;
      width: 100%;
      background: #e82035;
      line-height: 82px;
      border-radius: 50px;
      font-size: 26px;
      text-align: center;
      color: #fff;
    }
  }
  .other {
    text-align: center;
    font-size: 26px;
    line-height: 36px;
    padding-top: 40px;
    span {
      color: #aeaeae;
    }
  }
}
</style>
